// import { useState } from "react";
// import styles from "../../styles/__uploadRequiredDocuments.module.scss";
// import { useTranslation } from "react-i18next";
// import { Link, useNavigate } from "react-router-dom";

// export default function UploadDocuments() {
//   const { t, i18n } = useTranslation();
//   const [fields, setFields] = useState([
//     { label: "Government ID", file: null },
//     { label: "Medical Licenses", file: null },
//     { label: "Degree Certificates", file: null },
//     { label: "Profile Photo", file: null },
//     { label: "Additional Certification", file: null },
//   ]);

//   const navigate = useNavigate();

//   const handleFileChange = (index, file) => {
//     const newFields = [...fields];
//     newFields[index].file = file;
//     setFields(newFields);
//   };

//   const removeFile = (index) => {
//     handleFileChange(index, null);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Files to upload:", fields);
//     // Upload logic here

//     // navigate(`/documents-under-process`);
//   };

//   return (<>
//      <div className={styles["main-container"]}>
//       <main className={styles["main-content"]}>
//           <div className={styles["upload-content-wrapper"]}>
//         <form onSubmit={handleSubmit} >
//             <h2 className={styles["title-1"]}>{t("upload.title")}</h2>
//             <div className={styles["upload-grid"]}>
//               {fields.map((field, index) => (
//                 <div key={index} className={styles["upload-card"]}>
//                   <p className={styles["label"]}>{field.label}</p>

//                   <label className={`${styles["upload-box"]} ${field.file ? styles["uploaded"] : ""}`}>
//                     <input
//                       type="file"
//                       accept=".png,.jpg,.jpeg,.pdf"
//                       hidden
//                       onChange={(e) =>
//                         handleFileChange(index, e.target.files?.[0] || null)
//                       }
//                     />
//                     <div className={styles["upload-placeholder"]}>
//                         <div className={styles["icon-wrap"]}>
//                           <span>
//                             <img src="/icon-upload.png" alt="" />
//                           </span>
//                         </div>
//                        <h2>{t("upload.placeholder.title")}</h2>
//                         <small>{t("upload.placeholder.subtitle")}</small>
//                       </div>

//                   </label>
//                   {!field.file ? (
//                       <></>
//                     ) : (
//                       <div className={styles["file-preview"]}>
//                         <span className={styles["file-icon"]}>
//                           <img src="/icon-jpg.png" alt="" />

//                         </span>
//                         <span className={styles["file-name"]}>{field.file.name}</span>
//                         <button
//                           type="button"
//                           className={styles["remove-btn"]}
//                           onClick={() => removeFile(index)}
//                         >
//                           ✖
//                         </button>
//                       </div>
//                     )}
//                 </div>

//               ))}
//             </div>
//               <button type="submit" onClick={handleSubmit} className={styles["upload-btn"]}>
//                                    {t("upload.button.submit")}
//               </button>
//           </form>
//           </div>
//       </main>
//     </div>
//   </>);
// }

// working but image and doc is not saparated upload
// import { useDispatch, useSelector } from "react-redux";
// import { uploadedDoctorDocument } from "../../reducer/uploadedDoctorDocuments/uploadedDocReducer"; // adjust path
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import styles from "../../styles/__uploadRequiredDocuments.module.scss";
// import { useTranslation } from "react-i18next";

// export default function UploadDocuments() {
//   const { t } = useTranslation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   // const { loading, success, error } = useSelector((state) => state?.doctorDocuments);
//   const { loading, success, error } = "";

//   const [fields, setFields] = useState([
//     { label: "Government ID", file: null, doc_type: "GOV_ID" },
//     { label: "Medical Licenses", file: null, doc_type: "MEDICAL_LICENSE" },
//     { label: "Degree Certificates", file: null, doc_type: "DEGREE_CERTIFICATE" },
//     { label: "Profile Photo", file: null, doc_type: "AVATAR" },
//     { label: "Additional Certification", file: null, doc_type: "ADDITIONAL_CERT" },
//   ]);

//   const handleFileChange = (index, file) => {
//     const newFields = [...fields];
//     newFields[index].file = file;
//     setFields(newFields);
//   };

//   const removeFile = (index) => {
//     handleFileChange(index, null);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // 🔹 Here, normally you'd upload files to S3 first, get file URLs, then call API.
//     // For now, we simulate with placeholders (replace with real URLs from upload response)
//     const documents = fields.map((f) => ({
//       doc_type: f.doc_type,
//       file_url: `triyaq-documents/doctors/${f.label
//         .toLowerCase()
//         .replace(/\s+/g, "-")}/${Date.now()}_${f.label
//         .toLowerCase()
//         .replace(/\s+/g, "_")}.pdf`,
//       file_name: f.file ? f.file.name : "default.pdf",
//       status: "PENDING",
//     }));

//     dispatch(uploadedDoctorDocument({ documents }));
//   };

//   useEffect(() => {
//     if (success) {
//       navigate("/documents-under-process");
//     }
//   }, [success, navigate]);

//   return (
//     <div className={styles["main-container"]}>
//       <main className={styles["main-content"]}>
//         <div className={styles["upload-content-wrapper"]}>
//           <form onSubmit={handleSubmit}>
//             <h2 className={styles["title-1"]}>{t("upload.title")}</h2>
//             <div className={styles["upload-grid"]}>
//               {fields.map((field, index) => (
//                 <div key={index} className={styles["upload-card"]}>
//                   <p className={styles["label"]}>{field.label}</p>
//                   <label
//                     className={`${styles["upload-box"]} ${
//                       field.file ? styles["uploaded"] : ""
//                     }`}
//                   >
//                     <input
//                       type="file"
//                       accept=".png,.jpg,.jpeg,.pdf"
//                       hidden
//                       onChange={(e) =>
//                         handleFileChange(index, e.target.files?.[0] || null)
//                       }
//                     />
//                     <div className={styles["upload-placeholder"]}>
//                       <div className={styles["icon-wrap"]}>
//                         <img src="/icon-upload.png" alt="" />
//                       </div>
//                       <h2>{t("upload.placeholder.title")}</h2>
//                       <small>{t("upload.placeholder.subtitle")}</small>
//                     </div>
//                   </label>
//                   {field.file && (
//                     <div className={styles["file-preview"]}>
//                       <span className={styles["file-icon"]}>
//                         <img src="/icon-jpg.png" alt="" />
//                       </span>
//                       <span className={styles["file-name"]}>{field.file.name}</span>
//                       <button
//                         type="button"
//                         className={styles["remove-btn"]}
//                         onClick={() => removeFile(index)}
//                       >
//                         ✖
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>

//             <button type="submit" disabled={loading} className={styles["upload-btn"]}>
//               {loading ? "Uploading..." : t("upload.button.submit")}
//             </button>

//             {error && <p className={styles["error-msg"]}>❌ {error}</p>}
//           </form>
//         </div>
//       </main>
//     </div>
//   );
// }

import { useDispatch, useSelector } from "react-redux";
import { uploadedDoctorDocument } from "../../reducer/uploadedDoctorDocuments/uploadedDocReducer";
import {
  uploadDoctorMedia,
  uploadAvatar,
} from "../../reducer/media/mediaReducer";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/__uploadRequiredDocuments.module.scss";
import { useTranslation } from "react-i18next";
import { toast } from "../../components/app-toast";
import { isDoctorDocumentOptional } from "../../utils/doctorDocuments";
import useDoctorConsultationType from "../../hooks/useDoctorConsultationType";

export default function UploadDocuments() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // The degree certificate is optional for home-visit-only doctors.
  const consultationType = useDoctorConsultationType();
  const isOptional = (docType) =>
    isDoctorDocumentOptional(docType, consultationType);
  const { data, isLoading, error } = useSelector(
    (state) => state.doctorDocuments,
  );

  const [fields, setFields] = useState([
    // { label: "Government ID", file: null, doc_type: "GOV_ID", apiType: "doc", docTypeValue: "government-id", url: "" },
    {
      label: "medical-licenses",
      file: null,
      doc_type: "MEDICAL_LICENSE",
      apiType: "doc",
      docTypeValue: "medical-licenses",
      url: "",
    },
    {
      label: "degree-certificates",
      file: null,
      doc_type: "DEGREE_CERTIFICATE",
      apiType: "doc",
      docTypeValue: "degree-certificates",
      url: "",
    },

    // { label: "Profile Photo", file: null, doc_type: "AVATAR", apiType: "avatar", url: "" },
    // { label: "Additional Certification", file: null, doc_type: "ADDITIONAL_CERT", apiType: "doc", docTypeValue: "additional-certification", url: "" },
  ]);

  const [loadingIds, setLoadingIds] = useState([]); // track which file is uploading

  // Handle success/error states with toast notifications
  useEffect(() => {
    if (data && !isLoading && !error) {
      // Success case - show success toast and navigate
      toast.success(data?.message || t("upload.toast.uploadSuccess"));
      navigate("/documents-under-process");
    }
  }, [data, isLoading, error, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (error && !isLoading) {
      // Error case - show error toast
      toast.error(
        error?.message ||
          error ||
          t("upload.toast.uploadFailed"),
      );
    }
  }, [error, isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileChange = async (index, file) => {
    const newFields = [...fields];
    newFields[index].file = file;
    setFields(newFields);

    if (!file) return;

    try {
      setLoadingIds((prev) => [...prev, index]);

      const base64Data = await convertToBase64(file);
      let response;

      if (newFields[index].apiType === "avatar") {
        response = await dispatch(
          uploadAvatar({
            file_data: base64Data,
            filename: file.name,
            mime_type: file.type,
            description: "User profile avatar",
          }),
        ).unwrap();
      } else {
        response = await dispatch(
          uploadDoctorMedia({
            file_data: base64Data,
            filename: file.name,
            mime_type: file.type,
            docType: newFields[index].docTypeValue,
          }),
        ).unwrap();
      }

      // Save the uploaded file URL in state
      newFields[index].url = (await response?.s3_key) || response?.file_url;
      console.log("response?.data?.s3_key:", response);
      console.log("newFields:", newFields);
      setFields(newFields);
    } catch (error) {
      console.error("File upload failed:", error);
      const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        t("upload.toast.uploadFailedForFile", { fileName: file.name });
      toast.error(errMsg);
      newFields[index].file = null; // remove file on error
      setFields(newFields);
    } finally {
      setLoadingIds((prev) => prev.filter((i) => i !== index));
    }
  };

  const removeFile = (index) => {
    const newFields = [...fields];
    newFields[index].file = null;
    newFields[index].url = "";
    setFields(newFields);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const uploadResults = fields
      .filter((f) => f.url) // only take fields with uploaded URL
      .map((f) => ({
        doc_type: f.doc_type,
        file_url: f.url,
        file_name: f.file.name,
        status: "PENDING",
      }));

    if (uploadResults.length === 0) {
      toast.warning(t("upload.toast.uploadAtLeastOne"));
      return;
    }

    // Check if all required documents are uploaded. The degree certificate is
    // optional for home-visit-only doctors.
    const requiredDocs = ["MEDICAL_LICENSE", "DEGREE_CERTIFICATE"].filter(
      (docType) => !isOptional(docType),
    );
    const uploadedDocTypes = uploadResults.map((doc) => doc.doc_type);
    const missingDocs = requiredDocs.filter(
      (docType) => !uploadedDocTypes.includes(docType),
    );

    if (missingDocs.length > 0) {
      // Show the translated document names instead of the API enum values.
      const missingDocNames = missingDocs.map((docType) => {
        const field = fields.find((f) => f.doc_type === docType);
        return field ? t(field.label) : docType;
      });
      toast.warning(
        t("upload.toast.missingRequiredDocs", {
          documents: missingDocNames.join(", "),
        }),
      );
      return;
    }

    console.log("Submitting documents:", uploadResults);
    // Dispatch the action - success/error will be handled by useEffect watching Redux state
    dispatch(uploadedDoctorDocument({ documents: uploadResults }));
  };

  return (
    <div className={styles["main-container"]}>
      <main className={styles["main-content"]}>
        <div className={styles["upload-content-wrapper"]}>
          <form onSubmit={handleSubmit}>
            <h2 className={styles["title-1"]}>{t("upload.title")}</h2>
            <div className={styles["upload-grid"]}>
              {fields.map((field, index) => (
                <div key={index} className={styles["upload-card"]}>
                  {/* Required documents get a red asterisk; the degree
                      certificate is marked "(Optional)" for home-visit-only
                      doctors instead. */}
                  <p className={styles["label"]}>
                    {t(field.label) || field.label}
                    {isOptional(field.doc_type) ? (
                      ` ${t("upload.optional")}`
                    ) : (
                      <span className={styles["required"]} aria-hidden="true">
                        *
                      </span>
                    )}
                  </p>
                  <label
                    className={`${styles["upload-box"]} ${field.file ? styles["uploaded"] : ""}`}
                  >
                    <input
                      type="file"
                      accept=".png,.jpg,.jpeg,.pdf"
                      hidden
                      onChange={(e) =>
                        handleFileChange(index, e.target.files?.[0] || null)
                      }
                    />
                    <div className={styles["upload-placeholder"]}>
                      <div className={styles["icon-wrap"]}>
                        <img src="/icon-upload.png" alt={t("upload.icon.uploadAlt")} />
                      </div>
                      <h2>{t("upload.placeholder.title")}</h2>
                      <small>{t("upload.placeholder.subtitle")}</small>
                    </div>
                  </label>
                  {field.file && (
                    <div className={styles["file-preview"]}>
                      <span className={styles["file-icon"]}>
                        <img src="/icon-jpg.png" alt={t("upload.icon.fileAlt")} />
                      </span>
                      <span className={styles["file-name"]}>
                        {field.file.name}
                      </span>
                      {loadingIds.includes(index) && <span>{t("upload.status.uploading")}</span>}
                      <button
                        type="button"
                        className={styles["remove-btn"]}
                        onClick={() => removeFile(index)}
                      >
                        ✖
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className={styles["upload-btn"]}
            >
              {isLoading
                ? t("upload.button.submittingDocuments")
                : t("upload.button.submitDocuments")}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

// import { useDispatch, useSelector } from "react-redux";
// import { uploadedDoctorDocument } from "../../reducer/uploadedDoctorDocuments/uploadedDocReducer";
// import { uploadDoctorMedia, uploadAvatar } from "../../reducer/media/mediaReducer";
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import styles from "../../styles/__uploadRequiredDocuments.module.scss";
// import { useTranslation } from "react-i18next";

// export default function UploadDocuments() {
//   const { t } = useTranslation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const [fields, setFields] = useState([
//     { label: "Government ID", file: null, doc_type: "GOV_ID", apiType: "doc", docTypeValue: "government-id" },
//     { label: "Medical Licenses", file: null, doc_type: "MEDICAL_LICENSE", apiType: "doc", docTypeValue: "medical-licenses" },
//     { label: "Degree Certificates", file: null, doc_type: "DEGREE_CERTIFICATE", apiType: "doc", docTypeValue: "degree-certificate" },
//     { label: "Profile Photo", file: null, doc_type: "AVATAR", apiType: "avatar" },
//     { label: "Additional Certification", file: null, doc_type: "ADDITIONAL_CERT", apiType: "doc", docTypeValue: "additional-certification" },
//   ]);

//   const handleFileChange = (index, file) => {
//     const newFields = [...fields];
//     newFields[index].file = file;
//     setFields(newFields);
//   };

//   const removeFile = (index) => {
//     handleFileChange(index, null);
//   };

//   const convertToBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = (error) => reject(error);
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const uploadResults = [];

//       // Step 1: Upload each file
//       for (const field of fields) {
//         if (!field.file) continue; // Skip empty fields

//         const base64Data = await convertToBase64(field.file);

//         let response;

//         if (field.apiType === "avatar") {
//           // 🔹 Upload avatar
//           response = await dispatch(
//             uploadAvatar({
//               file_data: base64Data,
//               filename: field.file.name,
//               mime_type: field.file.type,
//               description: "User profile avatar",
//             })
//           ).unwrap();
//         } else {
//           // 🔹 Upload doctor document
//           response = await dispatch(
//             uploadDoctorMedia({
//               file_data: base64Data,
//               filename: field.file.name,
//               mime_type: field.file.type,
//               docType: field.docTypeValue,
//             })
//           ).unwrap();
//         }

//         // ✅ Push final upload result
//         uploadResults.push({
//           doc_type: field.doc_type,
//           file_url: response?.data?.s3_key || response?.data?.file_url,
//           file_name: field.file.name,
//           status: "PENDING",
//         });
//       }

//       // Step 2: Send all URLs to final API
//       if (uploadResults.length > 0) {
//         await dispatch(uploadedDoctorDocument({ documents: uploadResults })).unwrap();
//         navigate("/documents-under-process");
//       } else {
//         alert("Please upload at least one document before submitting.");
//       }
//     } catch (error) {
//       console.error("Upload failed:", error);
//     }
//   };

//   return (
//     <div className={styles["main-container"]}>
//       <main className={styles["main-content"]}>
//         <div className={styles["upload-content-wrapper"]}>
//           <form onSubmit={handleSubmit}>
//             <h2 className={styles["title-1"]}>{t("upload.title")}</h2>
//             <div className={styles["upload-grid"]}>
//               {fields.map((field, index) => (
//                 <div key={index} className={styles["upload-card"]}>
//                   <p className={styles["label"]}>{field.label}</p>
//                   <label
//                     className={`${styles["upload-box"]} ${field.file ? styles["uploaded"] : ""}`}
//                   >
//                     <input
//                       type="file"
//                       accept=".png,.jpg,.jpeg,.pdf"
//                       hidden
//                       onChange={(e) =>
//                         handleFileChange(index, e.target.files?.[0] || null)
//                       }
//                     />
//                     <div className={styles["upload-placeholder"]}>
//                       <div className={styles["icon-wrap"]}>
//                         <img src="/icon-upload.png" alt="upload" />
//                       </div>
//                       <h2>{t("upload.placeholder.title")}</h2>
//                       <small>{t("upload.placeholder.subtitle")}</small>
//                     </div>
//                   </label>
//                   {field.file && (
//                     <div className={styles["file-preview"]}>
//                       <span className={styles["file-icon"]}>
//                         <img src="/icon-jpg.png" alt="file icon" />
//                       </span>
//                       <span className={styles["file-name"]}>{field.file.name}</span>
//                       <button
//                         type="button"
//                         className={styles["remove-btn"]}
//                         onClick={() => removeFile(index)}
//                       >
//                         ✖
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>

//             <button type="submit" className={styles["upload-btn"]}>
//               Submit Documents
//             </button>
//           </form>
//         </div>
//       </main>
//     </div>
//   );
// }
